import {
  getCollectionOfDittoComponents,
  TextManager,
} from "Components/TextContext";
import {
  useCompletedFormState,
  useCoveragePriceCalculations,
} from "Store/priceCalculation/priceCalculationHooks";
import { getDeductible } from "../boatUtils";
import {
  coveragesForBoatType,
  coverageToDropForBoatType,
  defaultDeductibleForBoatType,
} from "./boatCoveragesUtils";

import { H3 } from "App/global-style";
import { CurrentPriceMessage } from "Components/CurrentPriceMessage/CurrentPriceMessage";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { coveragePriceDifference } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.helpers";
import { MultipleProductCoverages } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/MultipleProductCoverages";
import { SystemErrorAlert } from "Components/Form/Alert/SystemErrorAlert";
import { Subheader } from "Components/TextContext/commonComponentEnums";
import { TextComponentNameLevel1 } from "Components/TextContext/textConstants";
import { useFormikContext } from "formik";
import React from "react";
import { useSelector } from "react-redux";
import { BoatCoverage } from "Store/interfaces/products/coverage";
import { ReduxState } from "Store/rootReducer";
import { BOAT_FIND_STEP } from "../boatSteps";
import { BoatProductIntroFormValues } from "../ProductIntro/boatProductIntroInterfaces";
import { BoatDeductible } from "./BoatDeductible";
import { BoatProductPriceFormValues } from "./boatProductPriceInterfaces";

const { boat: boatCoverageCardTextComponents } = getCollectionOfDittoComponents(
  TextComponentNameLevel1.COVERAGE_CARD,
);

export const BoatCoverages = (): React.ReactElement => {
  const introForm = useCompletedFormState<BoatProductIntroFormValues>(
    BOAT_FIND_STEP.id,
  );
  const priceForm = useFormikContext<BoatProductPriceFormValues>();
  const { getText } = TextManager;
  const { isLoading } = useSelector(
    (state: ReduxState) => state.priceCalculation.priceCalculationResult,
  );
  const coverages = [...useCoveragePriceCalculations()]
    .sort(coveragePriceDifference)
    .filter((coverage) =>
      coveragesForBoatType(introForm.boatType).some(
        (boatTypeCoverage) => boatTypeCoverage === coverage[0],
      ),
    );
  if (coverages.length === 0) {
    return <SystemErrorAlert alertId="no-coverages" />;
  }

  return (
    <>
      <BoatDeductible formProps={priceForm} coverages={coverages} />

      <H3>{getText(Subheader.CHOOSE_COVERAGE)}</H3>

      <MultipleProductCoverages
        fieldName="coverage"
        coverages={coverages}
        coverageStandards={Object.values(BoatCoverage)}
        priceFilterValue={priceForm.values.deductible}
        product={ProductBackendName.BOAT}
        priceIsLoading={isLoading}
        textComponents={boatCoverageCardTextComponents}
        doNotShow={coverageToDropForBoatType(introForm.boatType)}
      />

      <CurrentPriceMessage
        productBackendName={ProductBackendName.BOAT}
        coverages={coverages}
        selectedPrices={[
          {
            selectedCoverage: priceForm.values.coverage,
            selectedDeductible: getDeductible(priceForm.values),
            defaultDeductible: defaultDeductibleForBoatType(introForm.boatType),
          },
        ]}
      />
    </>
  );
};
